<template>
  <f-form
    store="@freebe/entrepreneurs"
    :id="id"
  >
    <template #default="{ item }">
      <p class="is-bold color-blue-dark m-bottom-10">
        {{ documentType }} 
      </p>

      <div class="is-grid">
        <f-field 
          class="is-col-3"
          label="Dernier numéro"
        >
          <f-input 
            v-model="item[type].numero"
            format="int"
            :min="0"
            :readonly="!canEdit"
            long
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Configuré le"
        >
          <f-datepicker 
            v-model="item[type].configured_at"
            :readonly="!canEdit"
            long
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Renouvellement"
        >
          <f-select 
            v-model="item[type].refresh"
            :options="refreshOptions"
            :readonly="!canEdit"
            label="name"
            value="value"
            long
          >
            <template #header>
              {{ getRefreshLabel(item[type].refresh) }}
            </template>
          </f-select>
        </f-field>

        <span class="is-col-3"></span>

        <f-field 
          class="is-col-3"
          label="Modèles"
        >
          <f-select 
            v-model="numerotation"
            :options="patterns"
            :readonly="!canEdit"
            label="example"
            value="pattern"
            long
          >
            <template #header>
              {{ currentNumerotation }}
            </template>
          </f-select>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Personnaliser"
        >
          <f-select 
            v-model="newSlice"
            :options="slicesOptions"
            :readonly="!canEdit"
            label="description"
            value="slice"
            long
          >
            <template #header>
              {{ currentNumerotation }}
            </template>
          </f-select>
        </f-field>

        <div 
          class="is-col-12 is-margin-auto"
        >
          <edit-pattern  
            v-if="canEdit" 
            class="is-margin-auto"
            v-model="numerotation"
          ></edit-pattern> 
        </div>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed, reactive, watch, toRefs, markRaw } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import { useConstants } from '@freebe/sdk/constants'
  import EditPattern from './edit-pattern'
  import Constants from '@constants'

  // const Constants = useConstants('taxes')

  export default {
    props: {
      id: {
        type: String,
        required: true,
      },

      type: {
        type: String,
        required: true,
      },
    },

    setup (props) {
      const { get, patch } = useStore('@freebe/entrepreneurs')
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/entrepreneurs:patch')
      )

      const entrepreneur = computed(() => get(props.id))
      const documentType = computed(() => 
        props.type === 'invoices' ? 'Factures' : 'Devis'
      )
      const sliceTypes = []

      Object.values(Constants.numerotation.types).forEach(types => 
        sliceTypes.push(...types)
      )

      const state = reactive({
        numerotation: entrepreneur.value[props.type].numerotation.map(slice => ({ ...slice })),
        patterns: Constants.numerotation.patterns[props.type].map(pattern => {
          return {
            example: Constants.numerotation.setNumerotation(pattern),
            pattern: pattern,
          }
        }),
        currentNumerotation: computed(() => {
          return Constants.numerotation.setNumerotation(state.numerotation, {
            numero: entrepreneur.value[props.type].numero,
          })
        }),
        newSlice: null,
        slicesOptions: sliceTypes.map(slice => {
          return {
            description: slice.description,
            slice: slice,
          }
        }),
        refreshOptions: [{
          name: 'Tous les mois',
          value: Constants.numerotation.refreshInterval.monthly,
        }, {
          name: 'Tous les ans',
          value: Constants.numerotation.refreshInterval.yearly,
        }, {
          name: 'Jamais',
          value: Constants.numerotation.refreshInterval.never,
        }],
      })

      function getRefreshLabel (value) {
        return state.refreshOptions.find(item => item.value === value).name
      }

      watch(() => state.newSlice, newValue => {
        state.numerotation.push({ ...newValue })
      })

      watch(() => state.numerotation, newValue => {
        if (Array.isArray(newValue) && newValue?.length) {
          patch(props.id, {
            [props.type]: {
              ...entrepreneur.value[props.type],
              numerotation: newValue.map(item => ({ ...item }))
            }
          }, { local: true })
        }
      }, { deep: true })

      return {
        ...toRefs(state),
        getRefreshLabel,
        documentType,
        canEdit,
      }
    },

    components: {
      EditPattern,
    },
  }
</script>